/* GG · Product · Gallery — dots + counter sync via scroll.
   Independent of the buy-box section: talks to it only via Dawn's global
   PUB_SUB_EVENTS (variantChange), never DOM containment, so it can be
   reordered anywhere on the page relative to gg-product-buybox. */
(function () {
  'use strict';

  function initGallery(pdp) {
    var track = pdp.querySelector('[data-gg-pdp-track]');
    var slides = Array.prototype.slice.call(pdp.querySelectorAll('[data-gg-pdp-slide]'));
    var dots = Array.prototype.slice.call(pdp.querySelectorAll('[data-gg-pdp-dot]'));
    var counter = pdp.querySelector('[data-gg-pdp-current]');
    if (!track || slides.length < 2) return;

    /* -1, damit der erste sync() das DOM auch dann anfasst, wenn der
       Browser beim Reload eine Scrollposition wiederhergestellt hat. */
    var active = -1;

    function setActive(i) {
      if (i === active) return;
      active = i;
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
        d.setAttribute('aria-current', di === i ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(i + 1);
    }

    /* Aktiven Index aus der Scrollposition ableiten — NICHT aus der
       Reihenfolge der IntersectionObserver-Eintraege. Der Observer liefert
       seine erste Runde als einen Batch mit allen beobachteten Elementen,
       und ein forEach darueber laesst schlicht den LETZTEN sichtbaren
       gewinnen. Sobald mehr als eine Karte zu >=60% im Track steht — auf
       dem Desktop praktisch immer, dort sind alle Karten gleichzeitig
       sichtbar — sprang der Zaehler beim Laden deshalb auf die hoechste
       sichtbare Nummer statt auf die erste. Zusaetzlich haengt der Zeitpunkt
       dieser ersten Runde am Layout- und Sichtbarkeitszustand (im Hintergrund
       geladene Tabs bekommen sie gebuendelt erst beim Anzeigen), weshalb der
       Fehler mal auftrat und mal nicht. Ueber die Scrollposition ist das
       Ergebnis eindeutig und beim Laden zwangslaeufig 0. */
    function aktuellerIndex() {
      var scrollbar = track.scrollWidth - track.clientWidth;
      /* Am rechten Anschlag erreicht die letzte Karte den linken Rand nicht
         mehr; die Naechster-Rand-Suche bliebe sonst eine Karte zurueck. */
      if (scrollbar > 2 && track.scrollLeft >= scrollbar - 2) return slides.length - 1;
      var links = track.getBoundingClientRect().left;
      var best = 0, bestAbstand = Infinity;
      slides.forEach(function (el, i) {
        var abstand = Math.abs(el.getBoundingClientRect().left - links);
        if (abstand < bestAbstand - 0.5) { bestAbstand = abstand; best = i; }
      });
      return best;
    }

    var rafId = null;
    function sync() { rafId = null; setActive(aktuellerIndex()); }
    function anfordern() { if (rafId === null) rafId = requestAnimationFrame(sync); }

    track.addEventListener('scroll', anfordern, { passive: true });
    window.addEventListener('resize', anfordern);
    sync();

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = slides[i];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    // When the variant changes and the variant has a featured_media, scroll to it.
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var variant = evt && evt.data && evt.data.variant;
        if (!variant || !variant.featured_media) return;
        var target = pdp.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (!target) return;
        var idx = slides.indexOf(target);
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        if (idx > -1) setActive(idx);
      });
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.gg-pdp-gallery')).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
